export default "__VITE_ASSET__B7JX83BY__"